// extracted by mini-css-extract-plugin
export default {"paper":"HistoryView_paper__2wsu4","heading":"HistoryView_heading__3YCZG","field":"HistoryView_field__21d2Y","download":"HistoryView_download__3IpZK"};